// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__DbyqI","newExpiryDate":"styles_newExpiryDate__14-UM","footer":"styles_footer__1AUHi"};